module.exports = __webpack_public_path__ + "media/images/icons/flags/NE-28ef67ae16347c647500638ecd71d325.svg";